import pagesAndPermissions from '@/main/pagesAndPermissions'

export default pagesAndPermissions
